var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H6C2.68629 24 0 21.3137 0 18V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9271 6.55737C25.1992 6.55737 25.4219 6.78003 25.4219 7.05216V8.04175H10.5781V7.05216C10.5781 6.78003 10.8008 6.55737 11.0729 6.55737H24.9271ZM25.4219 11.0105V16.948C25.4219 17.2201 25.1992 17.4428 24.9271 17.4428H11.0729C10.8008 17.4428 10.5781 17.2201 10.5781 16.948V11.0105H25.4219ZM11.0729 5.073C9.98128 5.073 9.09375 5.96053 9.09375 7.05216V16.948C9.09375 18.0396 9.98128 18.9272 11.0729 18.9272H24.9271C26.0187 18.9272 26.9062 18.0396 26.9062 16.948V7.05216C26.9062 5.96053 26.0187 5.073 24.9271 5.073H11.0729ZM12.8047 14.474C12.3934 14.474 12.0625 14.8049 12.0625 15.2162C12.0625 15.6275 12.3934 15.9584 12.8047 15.9584H14.2891C14.7004 15.9584 15.0312 15.6275 15.0312 15.2162C15.0312 14.8049 14.7004 14.474 14.2891 14.474H12.8047ZM16.763 14.474C16.3517 14.474 16.0208 14.8049 16.0208 15.2162C16.0208 15.6275 16.3517 15.9584 16.763 15.9584H20.2266C20.6379 15.9584 20.9687 15.6275 20.9687 15.2162C20.9687 14.8049 20.6379 14.474 20.2266 14.474H16.763Z",
    fill: "#526077"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.410fea34607c1f0bbb90d4c84cfdee2f.svg";
export { ForwardRef as ReactComponent };